(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4912],{

/***/ 67599:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chinh-sach-giao-hang",
      function () {
        return __webpack_require__(30290);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41844);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93378);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55784);



const Chinhsachgiaohang = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "other-page-style mt-[80px]",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    content: "text/html; charset=UTF-8",
                    httpEquiv: "content-type"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                    type: "text/css",
                    dangerouslySetInnerHTML: {
                        __html: '\n      @import url(https://themes.googleusercontent.com/fonts/css?kit=ZWjJg3Z-BmxuodZeCNuZK1XXWJorhxyFDZ_kYLKF3KU);\n      ol {\n        margin: 0;\n        padding: 0;\n      }\n      table td,\n      table th {\n        padding: 0;\n      }\n      .c10 {\n        border-right-style: solid;\n        border-top-width: 0pt;\n        border-right-width: 0pt;\n        padding-left: 0pt;\n        border-left-width: 0pt;\n        border-top-style: solid;\n        background-color: #ffffff;\n        border-left-style: solid;\n        border-bottom-width: 0pt;\n        border-bottom-style: solid;\n        padding-right: 0pt;\n      }\n      .c4 {\n        border-right-style: solid;\n        padding: 5pt 5pt 5pt 5pt;\n        border-bottom-color: #000000;\n        border-top-width: 1pt;\n        border-right-width: 1pt;\n        border-left-color: #000000;\n        vertical-align: top;\n        border-right-color: #000000;\n        border-left-width: 1pt;\n        border-top-style: solid;\n        border-left-style: solid;\n        border-bottom-width: 1pt;\n        width: 154.5pt;\n        border-top-color: #000000;\n        border-bottom-style: solid;\n      }\n      .c5 {\n        border-right-style: solid;\n        padding: 5pt 5pt 5pt 5pt;\n        border-bottom-color: #000000;\n        border-top-width: 1pt;\n        border-right-width: 1pt;\n        border-left-color: #000000;\n        vertical-align: top;\n        border-right-color: #000000;\n        border-left-width: 1pt;\n        border-top-style: solid;\n        border-left-style: solid;\n        border-bottom-width: 1pt;\n        width: 135pt;\n        border-top-color: #000000;\n        border-bottom-style: solid;\n      }\n      .c7 {\n        color: #100d28;\n        font-weight: 400;\n        text-decoration: none;\n        vertical-align: baseline;\n        font-size: 12pt;\n        font-family: "Nunito";\n        font-style: normal;\n      }\n      .c3 {\n        color: #100d28;\n        font-weight: 700;\n        text-decoration: none;\n        vertical-align: baseline;\n        font-size: 12pt;\n        font-family: "Nunito";\n        font-style: normal;\n      }\n      .c19 {\n        padding-top: 0pt;\n        padding-bottom: 0pt;\n        line-height: 1.15;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      .c2 {\n        padding-top: 0pt;\n        padding-bottom: 10pt;\n        line-height: 1.15;\n        orphans: 2;\n        widows: 2;\n        text-align: center;\n      }\n      .c1 {\n        padding-top: 0pt;\n        padding-bottom: 0pt;\n        line-height: 1.15;\n        orphans: 2;\n        widows: 2;\n        text-align: justify;\n      }\n      .c0 {\n        padding-top: 10pt;\n        padding-bottom: 10pt;\n        line-height: 1.15;\n        orphans: 2;\n        widows: 2;\n        text-align: justify;\n      }\n      .c6 {\n        font-size: 12pt;\n        font-family: "Nunito";\n        color: #100d28;\n        font-weight: 700;\n      }\n      .c13 {\n        border-spacing: 0;\n        border-collapse: collapse;\n        margin-right: auto;\n      }\n      .c9 {\n        padding-top: 0pt;\n        padding-bottom: 0pt;\n        line-height: 1;\n        text-align: center;\n      }\n      .c14 {\n        text-decoration: none;\n        vertical-align: baseline;\n        font-size: 11pt;\n        font-style: normal;\n      }\n      .c17 {\n        background-color: #ffffff;\n        max-width: 468pt;\n        padding: 72pt 72pt 72pt 72pt;\n      }\n      .c11 {\n        font-family: "Nunito";\n        color: #100d28;\n        font-weight: 400;\n      }\n      .c20 {\n        color: #000000;\n        font-weight: 400;\n        font-family: "Arial";\n      }\n      .c12 {\n        font-style: italic;\n      }\n      .c18 {\n        font-size: 12pt;\n      }\n      .c16 {\n        height: 0pt;\n      }\n      .c15 {\n        page-break-after: avoid;\n      }\n      .c8 {\n        height: 11pt;\n      }\n      .title {\n        padding-top: 0pt;\n        color: #000000;\n        font-size: 26pt;\n        padding-bottom: 3pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      .subtitle {\n        padding-top: 0pt;\n        color: #666666;\n        font-size: 15pt;\n        padding-bottom: 16pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      li {\n        color: #000000;\n        font-size: 11pt;\n        font-family: "Arial";\n      }\n      p {\n        margin: 0;\n        color: #000000;\n        font-size: 11pt;\n        font-family: "Arial";\n      }\n      h1 {\n        border-right-style: solid;\n        color: #2e2e2e;\n        border-top-width: 0pt;\n        font-weight: 700;\n        padding-left: 0pt;\n        font-size: 12pt;\n        background-color: #ffffff;\n        border-left-style: solid;\n        font-family: "Times New Roman";\n        orphans: 2;\n        text-align: justify;\n        padding-top: 0pt;\n        border-right-width: 0pt;\n        padding-bottom: 0pt;\n        line-height: 1.15;\n        page-break-after: avoid;\n        border-left-width: 0pt;\n        border-top-style: solid;\n        border-bottom-width: 0pt;\n        border-bottom-style: solid;\n        widows: 2;\n        padding-right: 0pt;\n      }\n      h2 {\n        padding-top: 18pt;\n        color: #000000;\n        font-size: 16pt;\n        padding-bottom: 6pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      h3 {\n        padding-top: 16pt;\n        color: #434343;\n        font-size: 14pt;\n        padding-bottom: 4pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      h4 {\n        padding-top: 14pt;\n        color: #666666;\n        font-size: 12pt;\n        padding-bottom: 4pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      h5 {\n        padding-top: 12pt;\n        color: #666666;\n        font-size: 11pt;\n        padding-bottom: 4pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n      h6 {\n        padding-top: 12pt;\n        color: #666666;\n        font-size: 11pt;\n        padding-bottom: 4pt;\n        font-family: "Arial";\n        line-height: 1.15;\n        page-break-after: avoid;\n        font-style: italic;\n        orphans: 2;\n        widows: 2;\n        text-align: left;\n      }\n    '
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "c8 c19",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c14 c20"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c3",
                        children: "CH\xcdNH S\xc1CH GIAO H\xc0NG"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "c10 c1 c15",
                    id: "h.p5aaqaporeq",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c3",
                        children: "1. PHƯƠNG THỨC GIAO H\xc0NG"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1 c10",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c3",
                        children: "Giao h\xe0ng tại địa chỉ m\xe0 kh\xe1ch h\xe0ng y\xeau cầu"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "c10 c1 mb-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c11 c18",
                            children: "Playee"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c7",
                            children: "\xa0phục vụ giao h\xe0ng cho Kh\xe1ch h\xe0ng tr\xean to\xe0n quốc, ngoại trừ một số khu vực sau: X\xe3 Ho\xe0ng Sa (Huyện Ho\xe0ng Sa, Đ\xe0 Nẵng), X\xe3 Trường Sa, X\xe3 Song Tử T\xe2y, X\xe3 Sinh Tồn (Huyện Trường Sa, Kh\xe1nh H\xf2a), X\xe3 An Sơn, X\xe3 H\xf2n Tre, X\xe3 Lại Sơn, X\xe3 Nam Du (Huyện Ki\xean Hải, Ki\xean Giang), Huyện Bảo L\xe2m (L\xe2m Đồng), Huyện Ph\xfa Qu\xed (B\xecnh Thuận)."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "c10 c1 c15",
                    id: "h.179x9q6125tz",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c3",
                        children: "2. PH\xcd & THỜI GIAN GIAO H\xc0NG ƯỚC T\xcdNH"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    id: "t.5b29feafb1805a0062550e15144d16bdfed45bbb"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    id: "t.0"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("table", {
                    className: "c13",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                className: "c16",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c4",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c3",
                                                children: "Tuyến"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c5",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c3",
                                                children: "Thời gian giao h\xe0ng"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c4",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c3",
                                                children: "Cước ph\xed dự t\xednh"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                className: "c16",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c4",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c7",
                                                children: "Nội tỉnh (H\xe0 Nội)"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c5",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c7",
                                                children: "2-4 ng\xe0y"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c4",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c7",
                                                children: "30,000"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                className: "c16",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c4",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c7",
                                                children: "C\xe1c t\xecnh th\xe0nh kh\xe1c"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c5",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c7",
                                                children: "5-7 ng\xe0y"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                        className: "c4",
                                        colSpan: 1,
                                        rowSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "c9",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "c7",
                                                children: "50,000"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c6 c12",
                        children: "Lưu \xfd: Ph\xed giao h\xe0ng c\xf3 thể thay đổi t\xf9y v\xe0o trọng lượng kiện h\xe0ng sau khi đ\xf3ng g\xf3i"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "c10 c1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c6",
                            children: "Thời gian phục vụ giao h\xe0ng"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c7",
                            children: ": Playee phục vụ giao h\xe0ng trong giờ h\xe0nh ch\xednh thứ 2 đến thứ 7 (trừ Chủ nhật v\xe0 ng\xe0y Lễ, Tết). Trong trường hợp, qu\xfd kh\xe1ch đặt h\xe0ng sau 18h, thời gian giao h\xe0ng sẽ cộng dồn th\xeam 1 ng\xe0y."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "c10 c1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c6",
                            children: "Thời gian giao h\xe0ng:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c7",
                            children: "\xa0Trung b\xecnh từ 3-5 ng\xe0y l\xe0m việc."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "Đơn h\xe0ng sẽ được giao đến địa chỉ của kh\xe1ch h\xe0ng, ngoại trừ c\xe1c trường hợp như: khu vực văn ph\xf2ng hạn chế ra v\xe0o, khu vực chung cư/cao tầng (chỉ phục vụ giao tại ch\xe2n t\xf2a nh\xe0) hoặc b\xean trong c\xe1c khu vực hạn chế đi lại (khu vực qu\xe2n sự, bi\xean giới,…)."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "c10 c1 c15",
                    id: "h.ha3ipp5ryr9g",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c3",
                        children: "3. PH\xc2N ĐỊNH TR\xc1CH NHIỆM C\xc1C B\xcaN"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c3",
                        children: "3.1. Nghĩa vụ của b\xean vận chuyển"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Bảo đảm vận chuyển t\xe0i sản đầy đủ, an to\xe0n đến địa điểm đ\xe3 định, theo đ\xfang thời hạn."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Giao t\xe0i sản cho người c\xf3 quyền nhận."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Chịu chi ph\xed li\xean quan đến việc chuy\xean chở t\xe0i sản, trừ trường hợp c\xf3 thỏa thuận kh\xe1c."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Mua bảo hiểm tr\xe1ch nhiệm d\xe2n sự theo quy định của ph\xe1p luật."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Bồi thường thiệt hại cho b\xean thu\xea vận chuyển trong trường hợp b\xean vận chuyển để mất, hư hỏng t\xe0i sản, trừ trường hợp c\xf3 thỏa thuận kh\xe1c hoặc ph\xe1p luật c\xf3 quy định kh\xe1c."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1 c8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "c1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c11 c18",
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "c6",
                            children: "3.2. Quyền của b\xean vận chuyển"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Kiểm tra sự x\xe1c thực của t\xe0i sản, của vận đơn hoặc chứng từ vận chuyển tương đương kh\xe1c."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Từ chối vận chuyển t\xe0i sản kh\xf4ng đ\xfang với loại t\xe0i sản đ\xe3 thỏa thuận trong hợp đồng."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Y\xeau cầu b\xean thu\xea vận chuyển thanh to\xe1n đủ cước ph\xed vận chuyển đ\xfang thời hạn."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Từ chối vận chuyển t\xe0i sản cấm giao dịch, t\xe0i sản c\xf3 t\xednh chất nguy hiểm, độc hại, nếu b\xean vận chuyển"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "\xa0"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c6",
                        children: "3.3. Nghĩa vụ của b\xean thu\xea vận chuyển"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Trả đủ tiền cước ph\xed vận chuyển cho b\xean vận chuyển theo đ\xfang thời hạn, phương thức đ\xe3 thỏa thuận."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Cung cấp th\xf4ng tin cần thiết li\xean quan đến t\xe0i sản vận chuyển để bảo đảm an to\xe0n cho t\xe0i sản vận chuyển."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Tr\xf4ng coi t\xe0i sản tr\xean đường vận chuyển, nếu c\xf3 thỏa thuận. Trường hợp b\xean thu\xea vận chuyển tr\xf4ng coi t\xe0i sản m\xe0 t\xe0i sản bị mất, hư hỏng th\xec kh\xf4ng được bồi thường."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "\xa0"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c0",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c6",
                        children: "3.4. Nghĩa vụ của b\xean thu\xea vận chuyển"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Y\xeau cầu b\xean vận chuyển chuy\xean chở t\xe0i sản đến đ\xfang địa điểm, thời điểm đ\xe3 thỏa thuận."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Trực tiếp hoặc chỉ định người thứ ba nhận lại t\xe0i sản đ\xe3 thu\xea vận chuyển."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "\xa0"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c3",
                        children: "3.5. Tr\xe1ch nhiệm bồi thường thiệt hại"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- B\xean vận chuyển phải bồi thường thiệt hại cho b\xean thu\xea vận chuyển nếu để t\xe0i sản bị mất hoặc hư hỏng."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- B\xean thu\xea vận chuyển phải bồi thường thiệt hại cho b\xean vận chuyển v\xe0 người thứ ba về thiệt hại do t\xe0i sản vận chuyển c\xf3 t\xednh chất nguy hiểm, độc hại m\xe0 kh\xf4ng c\xf3 biện ph\xe1p đ\xf3ng g\xf3i, bảo đảm an to\xe0n trong qu\xe1 tr\xecnh vận chuyển."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "- Trường hợp bất khả kh\xe1ng dẫn đến t\xe0i sản vận chuyển bị mất, hư hỏng hoặc bị hủy hoại trong qu\xe1 tr\xecnh vận chuyển th\xec b\xean vận chuyển kh\xf4ng phải chịu tr\xe1ch nhiệm bồi thường thiệt hại, trừ trường hợp c\xf3 thỏa thuận kh\xe1c hoặc ph\xe1p luật c\xf3 quy định kh\xe1c."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1 c8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "c10 c1 c15",
                    id: "h.sqc8aia2yxe5",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c3",
                        children: "4. BẤT KHẢ KH\xc1NG"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c10 c1",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "Trong c\xe1c trường hợp c\xf3 ph\xe1t sinh dịch bệnh (Covid, SARS, …), thi\xean tai hoặc trong c\xe1c trường hợp bất khả kh\xe1ng tại thời điểm ph\xe1t sinh theo quy định của cơ quan quản l\xfd nh\xe0 nước, việc giao h\xe0ng sẽ thay đổi theo t\xecnh h\xecnh thực tế về quy định chuyển ph\xe1t h\xe0ng ho\xe1 của nh\xe0 nước, Playee được quyền từ chối giao h\xe0ng."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c10 c1 mb-8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c7",
                        children: "Trường hợp ph\xe1t sinh chậm trễ trong việc giao h\xe0ng v\xe0 cung ứng dịch vụ, Playee sẽ c\xf3 th\xf4ng b\xe1o kịp thời cho kh\xe1ch h\xe0ng v\xe0 tạo cơ hội để kh\xe1ch h\xe0ng c\xf3 thể hủy hợp đồng nếu muốn."
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "c1 c8",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "c11 c14"
                    })
                })
            ]
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .withTranslation */ .Zh)("common")(Chinhsachgiaohang));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2888,179], function() { return __webpack_exec__(67599); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);